// Import axios for http requests
import axios from 'axios';

// CustomStorage wrapper for localStorage
import CustomStorage from '@glenngijsberts/customstorage';

// Helpr functions
import { getHeaders, getToken, getAuth } from '@/helpers/auth';

class Auth {
    // Construct properties
    constructor(
        loginLocation,
        redirectAfterClearLog,
        rederictAfterAuthenticated,
        userLocation,
    ) {
        // Headers for http requests
        this.headers = getHeaders(getToken());
        // Login location
        this.loginLocation = loginLocation;
        // Path to redirect to after logging out
        this.redirectAfterClearLog = redirectAfterClearLog;
        // Path to redirect after logging in
        this.rederictAfterAuthenticated = rederictAfterAuthenticated;
        // Location for the me call
        this.userLocation = userLocation;

        axios.interceptors.response.use(
            null,
            error => new Promise((resolve, reject) => {
                // If the status of a response is 401 (unauthorized and is not coming from login)
                if (
                    error.response &&
                    error.response.status === 401 &&
                    !error.response.request.responseURL.endsWith(
                        this.loginLocation,
                    )
                ) {
                    // Run method that clears tokens
                    this.logout();
                } else {
                    reject(error);
                }
            }),
        );
    }

    login(email, password) {
        return new Promise((resolve, reject) => {
            const credentials = {
                email,
                password,
            };

            const tokens = {};

            axios({
                method: 'POST',
                url: this.loginLocation,
                data: credentials,
                headers: this.headers,
            })
                .then(response => {
                    const now = new Date().getTime() / 1000;

                    tokens.access_token = response.data.access_token;
                    tokens.expires_in = response.data.expires_in;
                    tokens.token_type = response.data.token_type;
                    // Refresh the token according the expires_in minus 20 minutes
                    tokens.refresh_at = now + response.data.expires_in - 1200;

                    resolve(tokens);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    setTokens(tokens) {
        return new Promise(resolve => {
            if (tokens.access_token && tokens.expires_in && tokens.token_type) {
                const expiresInMinutes = tokens.expires_in / 60;
                // Save the object in localStorage
                CustomStorage.set('auth', tokens, expiresInMinutes);
                resolve(tokens);
                // else redirect to login because you're not logged in (duh)
            } else {
                console.error('Tokens are not valid while setting them');
                window.location.href = this.redirectAfterClearLog;
            }
        });
    }

    getUser() {
        return new Promise((resolve, reject) => {
            axios({
                url: this.userLocation,
                headers: getHeaders(getToken()),
                method: 'GET',
            })
                .then(response => {
                    const auth = getAuth();
                    auth.user = response.data.data;

                    const expiresInMinutes = getAuth().expires_in / 60;
                    CustomStorage.set('auth', auth, expiresInMinutes);

                    resolve(auth.user);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

export default Auth;
